module.exports = __webpack_public_path__ + "static/img/icon_view.685d3045.svg";